<template>
  <div class="mod-goods">
    <div v-html="contentStr"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentStr: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$http.get(this.$api.goodsApi.getYnDetail, {}).then(({ data }) => {
        console.log(data);
        this.contentStr = data.data.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
